import React, { useState, useEffect } from "react";
import { Form, Input, Button, message, Card } from "antd";
import axiosInstance from '../axiosApi';

const COOLDOWN_KEY = "pwd_reset_cooldown_until";
const COOLDOWN_SECONDS = 60;

const PasswordResetForm = () => {
  const [loading, setLoading] = useState(false);
  const [cooldownRemaining, setCooldownRemaining] = useState<number>(() => {
    const until = parseInt(localStorage.getItem(COOLDOWN_KEY) || "0", 10);
    const remaining = Math.ceil((until - Date.now()) / 1000);
    return remaining > 0 ? remaining : 0;
  });

  useEffect(() => {
    if (cooldownRemaining <= 0) return;
    const timer = setInterval(() => {
      const until = parseInt(localStorage.getItem(COOLDOWN_KEY) || "0", 10);
      const remaining = Math.ceil((until - Date.now()) / 1000);
      if (remaining <= 0) {
        localStorage.removeItem(COOLDOWN_KEY);
        setCooldownRemaining(0);
      } else {
        setCooldownRemaining(remaining);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [cooldownRemaining]);

  const onFinish = async (values: any) => {
    if (cooldownRemaining > 0) return;
    setLoading(true);
    try {
      await axiosInstance.post("/api/password_reset/", values);
      const until = Date.now() + COOLDOWN_SECONDS * 1000;
      localStorage.setItem(COOLDOWN_KEY, String(until));
      setCooldownRemaining(COOLDOWN_SECONDS);
      message.success("Check your email for a reset link.");
    } catch (err: any) {
      console.error("Password reset request error", err);
      message.error("Could not send reset email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "5rem" }}>
      <Card style={{ width: 360 }}>
        <h2 style={{ textAlign: "center", marginBottom: 24 }}>
          Reset Password
        </h2>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Please enter your email" },
              { type: "email", message: "Enter a valid email" },
            ]}
          >
            <Input placeholder="you@example.com" />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            disabled={cooldownRemaining > 0}
            block
          >
            {cooldownRemaining > 0
              ? `Resend available in ${cooldownRemaining}s`
              : "Send Reset Link"}
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default PasswordResetForm;
